import React, { useState, useEffect, useContext } from 'react';
import { GetDealNetworkHierarchy } from '../../../services/DataService';
import SelectedStationsTable from './SelectedStationsTable';
import StationSelectionTableNew from './StationSelectionTableNew';
import { CampaignGoalEnum } from '../../../constants/Enums';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { getStations, getStationCount } from './CampaignStationsUtils';

const StationSelection = ({
    campaign,
    campaignBurst,
    readOnly = false,
    recalc,
    recalcOth,
    splitOrGoal,
    setSplitOrGoal,
    changeMade,
    selectedGoal,
    stationSelectType,
    setStationSelectType
}) => {
    const { formatNumber } = useContext(SystemSettingsContext);
    const [networks, setNetworks] = useState([]);
    const [stationCount, setStationCount] = useState(0);

    const handleStationsChange = (stations, updateSelectType = true, isUserInput = true) => {
        if (
            selectedGoal.goal === CampaignGoalEnum.BASEOTH ||
            selectedGoal.goal === CampaignGoalEnum.TARGETOTH ||
            selectedGoal.goal === CampaignGoalEnum.OVERALLBASEOTH ||
            selectedGoal.goal === CampaignGoalEnum.OVERALLTARGETOTH
        ) {
            // change column header
            setSplitOrGoal('Goal');
            recalcOth(stations, isUserInput);
        } else {
            // revert column header
            setSplitOrGoal('Natural Split');
            recalc(stations, isUserInput);
        }

        if (updateSelectType) {
            if (stations?.length === stationCount) {
                setStationSelectType('genius');
            } else {
                setStationSelectType('manual');
            }
        }
    };

    const setOverride = (value, station) => {
        const stations = campaignBurst ? [...campaignBurst.burstStations] : [...campaign.campaignStations];
        const found = stations.find((s) => s.id === station.id);
        if (
            selectedGoal.goal !== CampaignGoalEnum.BASEOTH &&
            selectedGoal.goal !== CampaignGoalEnum.TARGETOTH &&
            selectedGoal.goal !== CampaignGoalEnum.OVERALLBASEOTH &&
            selectedGoal.goal !== CampaignGoalEnum.OVERALLTARGETOTH &&
            selectedGoal.goal !== CampaignGoalEnum.BASEREACH &&
            selectedGoal.goal !== CampaignGoalEnum.TARGETREACH
        ) {
            const original = found.originalBudget;
            const newValue = parseFloat(value);
            if (original !== newValue) {
                const overridePercentage =
                    original > 0
                        ? formatNumber(value / original, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                          })
                        : 0;
                found.override = overridePercentage;
            } else {
                found.override = 0;
            }
        }
        found.budget = value;

        campaignBurst ? changeMade('burstStations', stations) : changeMade('campaignStations', stations);
    };

    const loadNetworks = async () => {
        GetDealNetworkHierarchy(campaign.ledgerId, campaign.dealVersionId, true).then((data) => {
            setNetworks(data);
            setStationCount(getStationCount(data));
        });
    };
    useEffect(async () => {
        loadNetworks();
    }, []);

    useEffect(async () => {
        loadNetworks();
    }, [campaign.ledgerId]);

    useEffect(() => {
        if (stationSelectType === 'genius') {
            const mutar = getStations(networks);
            if (campaignStationsNetworkChanged(mutar)) handleStationsChange(mutar, false, false);
        }
    }, [stationSelectType]);

    const campaignStationsNetworkChanged = (stations) => {
        if (campaignBurst) {
            if (campaignBurst.burstStations.length !== stations.length) {
                return true;
            }
            for (let i = 0; i < stations.length; i++) {
                if (campaignBurst.burstStations[i].id !== stations[i].id) {
                    return true;
                }
            }
        } else {
            if (campaign.campaignStations.length !== stations.length) {
                return true;
            }
            for (let i = 0; i < stations.length; i++) {
                if (campaign.campaignStations[i].id !== stations[i].id) {
                    return true;
                }
            }
        }

        return false;
    };

    useEffect(() => {
        if (stationSelectType === '' && stationCount > 0) {
            if (campaignBurst) {
                if (campaignBurst.burstStations?.length > 0 && stationCount !== campaignBurst.burstStations?.length) {
                    setStationSelectType('manual');
                } else {
                    setStationSelectType('genius');
                }
            } else {
                if (campaign.campaignStations?.length > 0 && stationCount !== campaign.campaignStations?.length) {
                    setStationSelectType('manual');
                } else {
                    setStationSelectType('genius');
                }
            }
        }
    }, [stationCount]);

    return (
        <div style={{ width: '100%', height: 675 }}>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 880px',
                    gridTemplateRows: '1fr',
                    gridGap: 30
                }}
            >
                <div style={{ gridRow: 1 / 2, gridColumn: 1 / 2 }}>
                    <StationSelectionTableNew
                        networks={networks}
                        campaignStations={campaignBurst ? campaignBurst.burstStations : campaign.campaignStations}
                        setSelectedStations={handleStationsChange}
                        disabled={readOnly}
                    />
                </div>

                <div style={{ gridRow: 1 / 2, gridColumn: 2 / 3 }}>
                    <SelectedStationsTable
                        campaignStations={campaignBurst ? campaignBurst.burstStations : campaign.campaignStations}
                        readOnly={readOnly}
                        setSelectedStations={handleStationsChange}
                        splitOrGoal={splitOrGoal}
                        setOverride={setOverride}
                        changeMade={changeMade}
                        selectedGoal={selectedGoal}
                    />
                </div>
            </div>
        </div>
    );
};

export default StationSelection;
